import React from 'react';
import { Table, Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

const AccountTable = ({ accounts, loading, onEdit, onDelete }) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'Id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'Name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'Type',
    },
    {
      title: 'Level',
      dataIndex: 'level',
      key: 'Level',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <Space size="middle">
          <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(record)} />
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(record.id)} />
        </Space>
      ),
    },
  ];

  return (
    <div className="table-responsive-wrapper">
      <Table
        columns={columns}
        dataSource={accounts}
        rowKey="Id"
        loading={loading}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default AccountTable;
